import axios from 'axios';
import {useState, useEffect} from 'react';

import {URLS} from '../config';
import {PartnersType} from '../types/PartnersType';

export const useGetPartners = () => {
  const [partners, setPartners] = useState<PartnersType[]>([]);
  const [partnersLoading, setPartnersLoading] = useState<boolean>(false);

  const getPartners = async () => {
    setPartnersLoading(true);

    try {
      const response = await axios.get(URLS.GET_PARTNERS_LOCAL);
      setPartners(response.data.partners);
    } catch (error) {
      console.error(error);
    } finally {
      setPartnersLoading(false);
    }
  };

  useEffect(() => {
    getPartners();
  }, []);

  return {partnersLoading, partners};
};
